import React, { useEffect, useState, useMemo } from "react";
import { Tabs, Tab, Box, Grid, Divider } from "@mui/material";
import SelectPostForWebApp from "../Admin/SelectPostForWebApp";
import OverAllStats from "../Admin/OverAllStats";
import { AgeRange, Ethnicity, Portal } from "../Admin/VoteBasedOn";
import { List } from "../Admin/Category";

 const AdminTabs = ({
  portal,
  setPortal,
  activeTab,
  setActiveTab,
}) => {
  const handleTabChange = (event, newValue) => setActiveTab(newValue);
  const { userRole, portalType } = localStorage;
  useEffect(() => {
  }, [activeTab]);
  const CategoryHeading = "Categories";
  const tabs = useMemo(() => {
    return [
      {
        label: "Overall Stats",
        divider: true,
        component: <OverAllStats setActiveTab={setActiveTab} />,
      },
      { label: CategoryHeading, divider: true, component: <List /> },

      {
        label: "Vote (By Portal Type)",
        divider: true,
        component: <Portal />,
      },
      {
        label: "Vote (By Age Range)",
        divider: true,
        component: <AgeRange />,
      },
      {
        label: "Vote (By Ethnicity)",
        divider:
          portalType == "winepilot" || userRole == "superadmin" ? true : false,
        component: <Ethnicity />,
      },

      portalType === "winepilot"
        ? {
            label: "Post tag map",
            divider: false,
            component: <SelectPostForWebApp />,
          }
        : null,
    ].filter((tab) => tab);
  }, [portalType, setActiveTab, userRole]);

  const tabLabels = tabs;

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        item
        md={12}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          style={{ overflow: "inherit" }}
          variant="scrollable"
          scrollButtons="auto"
          indicatorColor="none"
        >
          {tabLabels.map((tab, index) => (
            <Tab
              key={index}
              label={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div>{tab.label}</div>
                  {tab.divider && (
                    <Divider
                      orientation="vertical"
                      sx={{
                        marginLeft: 2,
                        border: "1px solid",
                        height: "22px",
                        backgroundColor: "#767676",
                        color: "#767676",
                      }}
                    />
                  )}
                </Box>
              }
              sx={{
                color: "#767676 !important",
                fontWeight: 700,
                fontSize: 13,
                padding: "10px !important",

                "&.Mui-selected": {
                  fontSize: 14,
                  color: "#7C10A7  !important",
                },
              }}
            />
          ))}
        </Tabs>
      </Grid>
      {tabLabels[activeTab] && tabLabels[activeTab].component}
    </>
  );
};
export default AdminTabs